var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container"},[_c('iframe',{ref:"iframe",attrs:{"width":_vm.iframeWidth,"height":_vm.iframeHeight,"src":_vm.iframeUrl},on:{"load":_vm.resizeIframe}})])}
var staticRenderFns = []

export { render, staticRenderFns }